import { render, staticRenderFns } from "./CarritoView.vue?vue&type=template&id=1c1966d4&scoped=true"
import script from "./CarritoView.vue?vue&type=script&lang=js"
export * from "./CarritoView.vue?vue&type=script&lang=js"
import style0 from "./CarritoView.vue?vue&type=style&index=0&id=1c1966d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1966d4",
  null
  
)

export default component.exports